import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Box,
  Divider,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SupportIssueInfoTab from './SupportIssueInfoTab';
import SupportCommunicationTab from './SupportCommunicationTab';

const PRIMARY = '#f25d27';

/**
 * @param {{
 *   issue: import('../../types/support').SupportIssueViewModel | null;
 *   open: boolean;
 *   onClose: () => void;
 *   onIssueChange: (issue: import('../../types/support').SupportIssueViewModel) => void;
 * }} props
 */
export default function SupportIssueDetailsDialog({
  issue,
  open,
  onClose,
  onIssueChange,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [tab, setTab] = useState(0);

  // Ao trocar de chamado, resetar tab
  useEffect(() => {
    if (issue?.key) {
      setTab(0);
    }
  }, [issue?.key]);

  if (!issue) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : '12px',
          height: isMobile ? '100%' : '85vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          color: '#333',
          pb: 0,
          pr: 6,
          fontSize: '0.95rem',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {issue.title}
      </DialogTitle>

      <IconButton
        onClick={onClose}
        size="small"
        sx={{ position: 'absolute', right: 12, top: 12, color: '#888' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <Box sx={{ px: 3, pt: 1 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{
            '& .MuiTabs-indicator': { backgroundColor: PRIMARY },
            '& .MuiTab-root': { textTransform: 'none', fontWeight: 500, fontSize: '0.88rem' },
            '& .Mui-selected': { color: `${PRIMARY} !important` },
          }}
        >
          <Tab label="Informações gerais" />
          <Tab label="Comunicação" />
        </Tabs>
      </Box>

      <Divider />

      <DialogContent
        sx={{
          flex: 1,
          overflowY: 'auto',
          pt: '20px !important',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {tab === 0 && (
          <SupportIssueInfoTab issue={issue} onIssueChange={onIssueChange} />
        )}
        {tab === 1 && (
          <SupportCommunicationTab issue={issue} onIssueChange={onIssueChange} />
        )}
      </DialogContent>
    </Dialog>
  );
}
